/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { CreateUserOptions, CreateUserResponses } from '../types/CreateUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Create a new user
 * {@link /v1/user}
 */
export function createUser<ThrowOnError extends boolean = true>(
  options: Options<CreateUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/user',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateUserResponses, ThrowOnError>>,
  )
}
